import React, { useMemo } from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import { Row } from "react-bootstrap";

import { formatDate } from "../../../helpers/date";

import { generateUniqueId } from "../../../utils";
import Loading from "../../common/Loading";

import {
  PROJECT_COLUMNS,
  CALL_COLUMNS,
  CALL_COLUMNS_WITH_NOTE,
  PREPAID_COLUMNS
} from "./columns";

const TimeTrackerList = ({ data, loading, filters }) => {
  const startDate = useMemo(
    () => new Date(filters.startDate).setUTCHours(13),
    [filters]
  );
  const endDate = useMemo(
    () => new Date(filters.endDate).setUTCHours(13),
    [filters]
  );

  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div>
      {data.map((contractGroup) => (
        <div key={generateUniqueId()} className="content-wrapper">
          <Row style={{ textAlign: "center" }}>
            <h4>{contractGroup.contract?.name}</h4>
          </Row>
          {contractGroup?.purchase_orders?.length ? (
            <ReactTable
              className="-highlight"
              data={contractGroup?.purchase_orders}
              columns={PREPAID_COLUMNS(
                contractGroup?.prepaidTotal?.toFixed(1) || 0.0
              )}
              pageSize={contractGroup?.purchase_orders?.length}
              showPagination={false}
              defaultSorted={[{ id: "createdOn", desc: false }]}
            />
          ) : null}
          {contractGroup.projects
            .filter((project) => project.calls.length)
            .map((projectGroup) => (
              <>
                <ReactTable
                  className="-highlight"
                  data={projectGroup.calls}
                  columns={
                    filters.showNotes
                      ? CALL_COLUMNS_WITH_NOTE(
                          startDate,
                          endDate,
                          projectGroup.billableHoursProject || 0
                        )
                      : CALL_COLUMNS(
                          startDate,
                          endDate,
                          projectGroup.billableHoursProject || 0
                        )
                  }
                  pageSize={projectGroup?.calls?.length || 0}
                  showPagination={false}
                  defaultSorted={[{ id: "arrival_date", desc: false }]}
                />
              </>
            ))}
          {contractGroup.contract_type?.label !== "BILLABLE" ? (
            <React.Fragment>
              <hr />
              <Row style={{ textAlign: "center" }}>
                <h4>{`Account Summary Information 1/1/${formatDate(
                  startDate,
                  "yyyy"
                )} - ${formatDate(endDate, "MM/dd/yyyy")}`}</h4>
              </Row>
            </React.Fragment>
          ) : null}
          <ReactTable
            className="-highlight"
            data={contractGroup.allCallsByProject}
            columns={PROJECT_COLUMNS(
              contractGroup.totalBillable || 0,
              contractGroup?.prepaidTotal?.toFixed(1) || 0.0,
              contractGroup?.prepaidTotal && contractGroup.balance
            )}
            pageSize={contractGroup.allCallsByProject.length}
            showPagination={false}
            defaultSorted={[{ id: "name", desc: false }]}
          />
        </div>
      ))}
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
TimeTrackerList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  filters: PropTypes.object
};

export default TimeTrackerList;
